import { Breadcrumbs } from "@/components/page";
import { TaskViews } from "@/components/tasks/TaskViews";
import { useProject } from "@/lib/project";

export function ProjectTasksPage() {
  const { pid, bundle } = useProject();
  return (
    <>
      <Breadcrumbs items={[{ label: bundle.project.name, to: `/p/${pid}` }, { label: "All tasks" }]} />
      <div className="px-6 pt-8 pb-4 md:px-12">
        <h1 className="text-[32px] leading-tight font-bold">Tasks & Issues</h1>
        <p className="mt-1 text-sm text-muted">Every task across all epics and sprints in {bundle.project.name}.</p>
      </div>
      <div className="pb-24">
        <TaskViews scope={{}} storageKey={`view:${pid}:project`} />
      </div>
    </>
  );
}
